import type { ContactPresetView } from '@/api/contacts'

/** The built-in views of the Contacts page, in menu order. '' = all contacts. */
export const PRESET_VIEWS: { value: ContactPresetView | ''; label: string; hint: string }[] = [
  { value: '', label: 'All contacts', hint: 'Everyone you can see' },
  { value: 'mine', label: 'My contacts', hint: 'Contacts you own' },
  { value: 'unassigned', label: 'Unassigned', hint: 'No owner yet — needs someone to pick it up' },
  { value: 'recent', label: 'Recently added', hint: 'Added in the last 7 days' },
  { value: 'stale', label: 'No activity in 30+ days', hint: 'Not contacted for a month, or never' },
  { value: 'no_next_contact', label: 'No next contact date', hint: 'Nothing scheduled to follow up' },
  { value: 'missing_details', label: 'Missing details', hint: 'No email, or no phone number' },
]
